<template>
    <Layout v-if="viewPage" >

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="alert alert-danger" v-if="errorMsg" >
                        {{errorMsg}}
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Registration Cancellation</h2>
                            <p>
                                Are You sure You want to Cancel your registration to attend the {{ conferenceTextData.name }} Conference
                            </p>
                        </div>
                        <div class="col-12" >
                            <button @click="run" class="btn btn-outline-clr btn-sm" > Yes </button>
                            <button @click="handleCancel" class="btn btn-outline-clr btn-sm" > No </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { mapGetters } from 'vuex';
import Api from '@/Api'

export default {
    name: 'ConfirmCancellation',
    components: {Layout},
    data() {
        return {
            cancellation_data: {},
            message: 'Your request under process ..... please wait.',
            errorMsg: "",
            viewPage:true,
        };
    },
    computed: {
        ...mapGetters(['conferenceTextData'])
    },
    methods: {
        run() {
            Api().post('auth/cancel-invitation', this.cancellation_data)
                .then(res => {
                    this.message = res.data.message;
                    window.location = '/auth/registration/mail/action/cancellation-confirmed';
                }).catch( err => {
                    if( err.response && err.response.data && err.response.data.errors && err.response.data.errors.length > 0)
                    {
                        this.errorMsg = err.response.data.errors[0].message;
                    }
                    else {
                        this.errorMsg = "Something went wrong ... please try again later";
                    }
                });
        },
        handleCancel()
        {
            window.location = '/';
        },
        setUrlData()
        {
            let location = window.location;
            let url = new URL(location.href);

            let client = JSON.parse(localStorage.getItem('client'));
            if(!client) client = {};

            this.cancellation_data = {
                cancelation_token: url.searchParams.get('cancelation_token'),
                client_id : client.client_id
            };
        }
    },
    beforeMount() {
        this.setUrlData();
        Api().post('auth/verify-cancellation-token' , this.cancellation_data)
        .then( res => this.viewPage = true )
        .catch( err => {
            window.location = "/";
        });
    }
};
</script>
